import { useState } from "react";
import TimePicker from "react-time-picker";

const EditSchedule = (props) => {

    const [startDay, setStartDay] = useState(props.new ? 'MON' : props.schedule.startDay);
    const [endDay, setEndDay] = useState(props.new ? 'FRI' : props.schedule.endDay);
    const [startHour, setStartHour] = useState(props.new ? '07:00' : props.schedule.startHour);
    const [endHour, setEndHour] = useState(props.new ? '17:00' : props.schedule.endHour);
    const [isOff, setOff] = useState(props.new ? false : props.schedule.isOff);

    const save = () => {
        const newSchedules = props.schedules.slice();
        if(props.new){
            if(newSchedules[props.schedulesPos]){
                newSchedules[props.schedulesPos].push({startDay: startDay, endDay: endDay, startHour: startHour, endHour: endHour, isOff: isOff});
                props.setSchedules(newSchedules);
            }else{
                newSchedules[props.schedulesPos] = [{startDay: startDay, endDay: endDay, startHour: startHour, endHour: endHour, isOff: isOff}];
                props.setSchedules(newSchedules);
            }
            props.close();
        }else if(props.delete){
            newSchedules[props.schedulesPos] = newSchedules[props.schedulesPos].filter(element => element != props.schedule);props.setSchedules(newSchedules);
            props.close();
            
        }else{
            newSchedules[props.schedulesPos][props.schedulePos] = {...props.schedule, startDay: startDay, endDay: endDay, startHour: startHour, endHour: endHour, isOff: isOff};props.setSchedules(newSchedules);
            props.close();
        }

        props.export('Schedules', props.schedulesPos, 'schedules', newSchedules[props.schedulesPos]);
    }

    return (
        <>
            <span className="subtitle">Dias</span>
            <div className="pl-1 my-1 d-grid grid-label-input">
                <div>
                    De:
                </div>
                <select style={{fontSize: '1rem'}} value={startDay} onChange={(e) => setStartDay(e.target.value)} disabled={props.delete ? true : false}>
                    <option value="MON">Lunes</option>
                    <option value="TUE">Martes</option>
                    <option value="WED">Miercoles</option>
                    <option value="THU">Jueves</option>
                    <option value="FRI">Viernes</option>
                    <option value="SAT">Sabado</option>
                    <option value="SUN">Domingo</option>
                </select>
            </div>
            <div className="pl-1 pb-1 d-grid grid-label-input">
                <div>
                    A:
                </div>
                <select style={{fontSize: '1rem'}} value={endDay} onChange={(e) => setEndDay(e.target.value)}  disabled={props.delete ? true : false}>
                    <option value="MON">Lunes</option>
                    <option value="TUE">Martes</option>
                    <option value="WED">Miercoles</option>
                    <option value="THU">Jueves</option>
                    <option value="FRI">Viernes</option>
                    <option value="SAT">Sabado</option>
                    <option value="SUN">Domingo</option>
                </select>
            </div>
            <span className="subtitle">Horario</span>
            <div className="pl-1 mt-1 d-grid grid-label-input">
                De:
                <TimePicker disabled={isOff || props.delete} value={startHour} onChange={setStartHour} clockIcon={null} disableClock/>
            </div>
            <div className='pl-1 mt-1 d-grid grid-label-input'>
                A:
                <TimePicker disabled={isOff || props.delete} value={endHour} onChange={setEndHour} clockIcon={null} disableClock />
            </div>
            <div className='pl-1 mt-2 d-grid grid-label-input'>
                <input type='checkbox' checked={isOff} onChange={(e) => setOff(e.target.checked)}  disabled={props.delete ? true : false}/>
                <label>Cerrado</label>
            </div>
            <div className="mt-2">
                <button className={props.delete ? 'm-auto btn btn-cancel':'m-auto btn btn-accept'} onClick={save}>{props.delete? 'Borrar':'Guardar'}</button>
            </div>
        </>
    );
}

export default EditSchedule;